// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".Header{box-shadow:0 2px 20px -9px rgba(0,0,0,0.2);z-index:99}.Header .Separator{height:100%;border-right:1px solid #c2cfe6}.Header .Logo{width:38px;height:38px}\n", ""]);
// Exports
module.exports = exports;
